import { createFileRoute, redirect } from '@tanstack/react-router';

/** Attendance lives under Class Management — keep old HR URL working. */
export const Route = createFileRoute('/portal/managers/hr/attendance')({
  beforeLoad: () => {
    throw redirect({
      to: '/portal/managers/classes',
      search: { section: 'daily' },
    });
  },
});
